import { itemPages } from '../../../config/constantLists'
const DashboardLayout = () => import('../../../layouts/DashboardLayout.vue')
const SystemWallets = () => import('./views/SystemWallets')
const SystemWalletView = () => import('./views/SystemWalletView')

export default [
  {
    path: '/system-wallets',
    component: DashboardLayout,
    meta: { auth: true },
    children: [
      {
        path: '',
        name: 'transactions.systemWallets',
        meta: { auth: true },
        component: SystemWallets
      },
      {
        path: 'view/:id?',
        name: 'transactions.systemWalletView',
        meta: { auth: true, currentPage: itemPages.view },
        component: SystemWalletView,
        props: true
      }
    ]
  }
]
